<template>
  <div class="whatsapp-wrapper">
    <iframe
      width="100"
      height="50"
      style="border: 0"
      :src="whatsAppLink"
    ></iframe>
  </div>
</template>

<script>
import { getDomainTheme } from "../utils/domains-theme.js";
import { config } from "../helpers/domain-config";

export default {
  data() {
    const themeConfig = getDomainTheme(config.productName);
    return {
      whatsAppLink: themeConfig[config.subdomain]
        ? themeConfig[config.subdomain].whatsappUrl
        : null,
    };
  },
};
</script>

<style lang="scss">
.whatsapp-wrapper {
  font-family: system-ui;
  position: fixed;
  right: 120px;
  bottom: 10px;
  opacity: 0;

  &.visible {
    opacity: 1;
  }

  &.animated {
    transition: 1s;
  }

  .whatsapp-tooltip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 85px;
    right: 61px;

    .tooltipText_span {
      background: white;
      padding: 10px 14px;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      white-space: nowrap;
      margin-right: 10px;
    }
  }

  .tooltip_cancel {
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
  }

  .whatsapp-float {
    width: 70px;
    height: 70px;
    color: #fff;
    background-color: #25d366;
    border-radius: 50%;
    text-align: center;
    font-size: 30px;
    box-shadow: 2px 2px 3px #999;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: transform 0.2s ease-out;
  }

  .whatsapp-float img {
    width: 40px;
  }

  .whatsapp-float:hover {
    background-color: #20b857;
    transform: scale(1.1);
  }
}
@media screen and (max-width: 640px) {
  .whatsapp-wrapper {
    right: 100px;
  }
}
</style>
